import { useCallback, useState } from 'react'
import { Pagination } from '../types/objectsFilter.type'

type UsePaginationArgs = {
  initialPagination?: Partial<Pagination>
}

const INITIAL_PAGINATION = { limit: 10, offset: 0 }

export default function usePagination({
  initialPagination = INITIAL_PAGINATION
}: UsePaginationArgs = {}) {
  const [pagination, setPagination] = useState(initialPagination)

  const setPage = useCallback((page: number) => {
    setPagination((oldPagination) => {
      if (!oldPagination.limit) return oldPagination

      const newOffset = (page - 1) * oldPagination.limit
      if (newOffset === oldPagination.offset) return oldPagination

      return {
        ...oldPagination,
        offset: newOffset
      }
    })
  }, [])

  const updatePagination = useCallback((newPagination: Partial<Pagination>) => {
    setPagination((oldPagination) => ({
      ...oldPagination,
      ...newPagination
    }))
  }, [])

  return {
    pagination,
    setPage,
    setPagination: updatePagination
  }
}
